import TeaserSlider from '../teaser-slider/TeaserSlider';

const mql = window.matchMedia('(min-width: 830px)');

class TopicGrid extends TeaserSlider {
  constructor($topicGrid, mq) {
    super($topicGrid, mq, {
      showDots: true,
      scrollContainerClass: '.topic-grid__inner',
      itemsContainerClass: '.topic-grid__teasers',
      itemClass: '.topic-grid__teaser',
      resizeVerticalImages: false,
      positionControlsOnImages: false,
    });
  }
}

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];
  const isDesktop = mq.matches;
  const $topicGrids = document.querySelectorAll('.topic-grid');

  if (!isDesktop) {
    $topicGrids?.forEach(($slider) => {
      const $parentPageSection = $slider.closest('.page__section');
      componentStore.push(new TopicGrid($slider, mq));
      $parentPageSection?.classList.add('topic-grid__breaker');
    });
  } else {
    componentStore.forEach(
      (component) => component.deconstructor && component.deconstructor()
    );
    $topicGrids?.forEach(($slider) => {
      $slider
        .closest('.page__section')
        ?.classList.remove('topic-grid__breaker');
    });
  }
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
